<template>
	<div class="homework-row">
		<label>
			{{ 'Game type' | translate }}
			<select v-model="config.type" class="form-control">
				<option :value="type.value" v-for="(type, index) in gameTypes" :key="index">
					{{ type.label | translate }}
				</option>
			</select>
		</label>

		<label>
			{{ 'Calculation method' | translate }}
			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="oral" />
					{{ 'Imaginary abacus' | translate }}
				</label>
			</div>

			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="abacus" />
					{{ 'Abacus' | translate }}
				</label>
			</div>
		</label>

		<label class="text-capitalize">
			{{ 'divided' | translate }}
			<select required v-model="config.options.numbers[0]" class="form-control">
				<option :value="difficult" v-for="(difficult, index) in difficult" :key="index">
					{{ difficult }}
				</option>
			</select>
		</label>
		<label class="text-capitalize">
			{{ 'divider' | translate }}
			<select required v-model="config.options.numbers[1]" class="form-control">
				<option :value="difficult" v-for="(difficult, index) in difficult2" :key="index">
					{{ difficult }}
				</option>
			</select>
		</label>
		<label>
			{{ 'Number of expressions' | translate }}
			<input type="number" :value="config.repeat" @input="onInputRepeat" @blur="onBlurRepeat" min="1" max="10" step="1"
				class="form-control" />
		</label>
	</div>
</template>

<script>
// import { DEFAULT_DIVIDE_OPTIONS } from '../Create.vue'
// import mergeDeep from '../../../../helpers/deepMerge'

export default {
	name: 'divide',
	props: {
		config: Object,
		onInputRepeat: Function,
		onBlurRepeat: Function,
		gameTypes: Array,
	},
	// created() {
	// 	if (this.config.id || this.config.is_created) {
	// 		this.config.id = undefined


	// 		if (this.config.options.type && this.config.options.type != 'divide') {
	// 			this.config.options = JSON.parse(JSON.stringify(DEFAULT_DIVIDE_OPTIONS))
	// 		}
	// 	} else {
	// 		// small super-fast fix for make new config object
	// 		this.config.options = JSON.parse(JSON.stringify(DEFAULT_DIVIDE_OPTIONS))
	// 	}

	// 	this.config.is_created = true
	// },
	computed: {
		difficult2: () => [100, 10, 1],
		difficult: () => [1000, 100, 10],
	},
}
</script>
